import { isValidIBAN } from 'ibantools';

export const isValidIban = (input: string): boolean => {
  const iban = input.replaceAll(/\s+/g, '').toUpperCase();
  return isValidIBAN(iban);
};
